export default {
  hasMore: true,
  isFetching: false,
  items: [],
  filterHistory: [],
  total: 0,
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/basicFeed.js